// A plain string entry is required (AND). A nested array means "any of" (OR).
export type RequiredPermissions = (string[] | string)[];
// One of `roles` is required, unless the user holds one of `orPermissions`, which stand in for them.
export type RequiredRoles = { orPermissions?: string[]; roles: string[] } | undefined;

export const hasRequiredPermissions = (
  userPermissions: string[],
  requiredPermissions: RequiredPermissions,
): boolean =>
  requiredPermissions.length === 0 ||
  requiredPermissions.every(it =>
    Array.isArray(it) ? it.some(p => userPermissions.includes(p)) : userPermissions.includes(it),
  );

export const hasRequiredRoles = (
  userRoles: string[],
  userPermissions: string[],
  requiredRoles: RequiredRoles,
): boolean =>
  !requiredRoles?.roles.length ||
  requiredRoles.roles.some(role => userRoles.includes(role)) ||
  Boolean(requiredRoles.orPermissions?.some(permission => userPermissions.includes(permission)));

export const hasRouteAccess = (
  userPermissions: string[],
  userRoles: string[],
  requiredPermissions: RequiredPermissions,
  requiredRoles: RequiredRoles,
): boolean =>
  hasRequiredRoles(userRoles, userPermissions, requiredRoles) &&
  hasRequiredPermissions(userPermissions, requiredPermissions);
